import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  onClick?: () => void;
}
const paddingStyles = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6'
};
export function Card({
  children,
  className = '',
  padding = 'md',
  onClick
}: CardProps) {
  return <div className={`
        relative
        bg-white dark:bg-gray-800
        border border-gray-200 dark:border-gray-700
        rounded-xl shadow-sm
        ${paddingStyles[padding]}
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `} onClick={onClick} data-id="element-4778">
      {children}
    </div>;
}
interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}
export function CardHeader({
  children,
  className = ''
}: CardHeaderProps) {
  return <div className={`pb-4 border-b border-gray-200 dark:border-gray-700 ${className}`} data-id="element-4779">
      {children}
    </div>;
}
interface CardTitleProps {
  children: React.ReactNode;
  className?: string;
}
export function CardTitle({
  children,
  className = ''
}: CardTitleProps) {
  return <h3 className={`text-lg font-semibold text-gray-900 dark:text-white ${className}`} data-id="element-4780">
      {children}
    </h3>;
}
interface CardContentProps {
  children: React.ReactNode;
  className?: string;
}
export function CardContent({
  children,
  className = ''
}: CardContentProps) {
  return <div className={`pt-4 ${className}`} data-id="element-4781">{children}</div>;
}